const ALL_WHITE_SPACE_REGEX = /\s/gi

export const replaceAllSpacesInStringWith = (
  str = '',
  replaceStr: string
): string => str.replace(ALL_WHITE_SPACE_REGEX, replaceStr)

export const replaceAllSpacesWithDashes = (str: string) =>
  replaceAllSpacesInStringWith(str, '-')
